import { View, Text, styled } from 'tamagui'
import { channelPermissions } from '@/mocks/roles'
import { roles } from '@/mocks/roles'

const Popover = styled(View, {
  width: 200,
  backgroundColor: '$surfaceRaised',
  borderRadius: '$borderRadiusLg',
  borderWidth: 1,
  borderColor: '$borderDefault',
  padding: 10,
  gap: 6,
})

const PopoverTitle = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 11,
  fontWeight: '600',
  color: '$color8',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
})

const RoleRow = styled(View, {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 6,
  paddingVertical: 3,
})

const RoleDot = styled(View, {
  width: 8,
  height: 8,
  borderRadius: '$borderRadiusFull',
})

const RoleName = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 12,
  color: '$surfaceForeground',
})

interface ChannelPermissionsPopoverProps {
  channelId: string
  serverId: string
}

export function ChannelPermissionsPopover({ channelId, serverId }: ChannelPermissionsPopoverProps) {
  const roleIds = channelPermissions[channelId] || []
  const serverRoles = roles[serverId] || []
  const matchedRoles = roleIds
    .map((id) => serverRoles.find((r) => r.id === id))
    .filter(Boolean)

  if (matchedRoles.length === 0) return null

  return (
    <Popover>
      <PopoverTitle>Channel Access</PopoverTitle>
      {matchedRoles.map((role) => (
        <RoleRow key={role!.id}>
          <RoleDot backgroundColor={role!.color} />
          <RoleName>{role!.name}</RoleName>
        </RoleRow>
      ))}
    </Popover>
  )
}
